import {
  HistoryOutlined,
  InsertDriveFile,
  Vaccines,
} from "@mui/icons-material";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import ChipTabs from "../../../components/ChipsTabs";
import DetailCard from "../../../components/display/DetailCard";
import TextEditorViewer from "../../../components/display/TextEditorViewer";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import {
  CREATE_TREATMENT,
  EDIT_TREATMENT,
  VIEW_AUDITING,
} from "../../../enums/PermissionTitles";
import useUser from "../../../hooks/useUser";
import { useIsMobile } from "../../../utils/Functions";
import AppointmentBiometrics from "../../biometrics/components/AppointmentBiometrics";
import ToggleFileUpload from "../context/ToggleFileUpload";
import AppointmentFiles from "./display/AppointmentFiles";
import AppointmentDeltas from "./revisions/AppointmentDeltas";
import { Box, Paper, Stack } from "@mui/material";
import MedicationIcon from "@mui/icons-material/Medication";
import ListOfVaccines from "./tabs/components/ListOfVaccines";
import { STATUSES } from "../../../enums/AppointmentStatus";
const TREATMENT = "Treatment";
const BIOMETRICS = "Biometrics";

export default function Information({
  object_info,
  status,
  appointmentClinicId,
}) {
  const { roles, currentClinic } = useUser();
  const isMobile = useIsMobile();
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const historyPermission = isPermissionAllowed(VIEW_AUDITING);
  const treatmentPermission =
    isPermissionAllowed(CREATE_TREATMENT) ||
    isPermissionAllowed(EDIT_TREATMENT);
  const { t } = useTranslation();

  const valueArray = object_info
    .filter((item) => item?.label !== TREATMENT)
    .map((item) => ({
      value: item.value,
      title: item.label,
      testId: `appointment.details.field-${item.label}`,
    }));

  const treatmentObj = object_info
    .filter((item) => item?.label == TREATMENT)
    .map((item) => ({
      value: t(item.value),
      title: item.label,
    }));

  const chipTitles = [];
  const chipContent = [];
  const chipIcons = [];
  const chipTestIds = [];
  const canUploadFile =
    status == STATUSES.ACTIVE ||
    status == STATUSES.FINISHED ||
    status == STATUSES.RESOLVED;
  const canSeeHistory =
    roles.master ||
    (appointmentClinicId && appointmentClinicId === currentClinic?.id);

  if (canUploadFile) {
    chipTitles.push("Files");
    chipContent.push(
      <ToggleFileUpload>
        <Paper sx={{ p: 2 }}>
          <AppointmentFiles />
        </Paper>
      </ToggleFileUpload>,
    );
    chipIcons.push(<InsertDriveFile />);
    chipTestIds.push("appointment.details.tabs.files");
  }

  if (
    (roles.user || treatmentPermission) &&
    treatmentObj[0]?.value != t("NoInfo")
  ) {
    chipTitles.push("Treatment");
    chipContent.push(
      <Paper sx={{ p: 1 }}>
        <TextEditorViewer value={treatmentObj[0].value} />
      </Paper>,
    );
    chipIcons.push(<MedicationIcon />);
    chipTestIds.push("appointment.details.tabs.treatment");
  }

  if (String(status).toUpperCase() === STATUSES.FINISHED) {
    chipTitles.push("Biometrics");
    chipContent.push(<AppointmentBiometrics showForm={false} />);
    chipIcons.push(<ThermostatIcon />);
    chipTestIds.push("appointment.details.tabs.biometrics");

    chipTitles.push("Vaccines");
    chipIcons.push(<Vaccines />);
    chipContent.push(<ListOfVaccines />);
    chipTestIds.push("appointment.details.tabs.vaccines");
  }

  if (!roles.user && historyPermission && canSeeHistory) {
    chipTitles.push("History");
    chipContent.push(<AppointmentDeltas />);
    chipIcons.push(<HistoryOutlined />);
    chipTestIds.push("appointment.details.tabs.history");
  }

  var pushRight = 0;
  if (roles?.user) {
    pushRight = 0;
  } else if (chipTitles.includes("History")) {
    var len =
      Number(String(chipTitles.length).slice(0, String(chipTitles.length))) - 1;
    pushRight = len;
  }

  const isSingleChip = chipTitles.length == 1 && chipTitles.includes("History");

  return (
    <Fragment>
      <DetailCard
        valueArray={valueArray}
        grid={!isMobile}
        gridCount={2}
        elevation={4}
      />
      <Box mt={3}>
        <ChipTabs
          lsKey={"INFORMATION_LS_KEY"}
          pushRight={pushRight}
          contentAlign={isSingleChip ? "right" : "left"}
          tabContent={chipContent}
          tabLabels={chipTitles}
          icons={chipIcons}
          tabTestIds={chipTestIds}
          wrapperMaxWidth="90vw"
        />
      </Box>
    </Fragment>
  );
}
